import type { ToolPreset } from "../types/presets";

const modules = import.meta.glob("../presets/**/*.json", { eager: true });

export function getBuiltInPresets(toolId: string): ToolPreset[] {
    const presets: ToolPreset[] = [];
    const segment = `/presets/${toolId}/`;

    for (const [path, mod] of Object.entries(modules)) {
        if (!path.includes(segment)) continue;
        const data = (mod as { default: unknown }).default as ToolPreset;
        if (data && typeof data === "object" && typeof data.name === "string" && data.values) {
            presets.push(data);
        }
    }

    return presets;
}

export function exportPreset(preset: ToolPreset): void {
    const json = JSON.stringify(preset, null, 4);
    const blob = new Blob([json], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${preset.name.replace(/\s+/g, "-").toLowerCase()}.json`;
    a.click();
    URL.revokeObjectURL(url);
}

export function parseImportedPreset(json: string): ToolPreset {
    const data = JSON.parse(json);
    if (
        !data ||
        typeof data !== "object" ||
        typeof data.name !== "string" ||
        !data.name ||
        !data.values ||
        typeof data.values !== "object"
    ) {
        throw new Error("Invalid preset file: must contain 'name' (string) and 'values' (object).");
    }
    return {
        name: data.name,
        description: typeof data.description === "string" ? data.description : undefined,
        values: data.values as Record<string, unknown>,
    };
}
